import { render } from "./WebCreate.vue?vue&type=template&id=5e725803"
import script from "./WebCreate.vue?vue&type=script&lang=js"
export * from "./WebCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__